module.exports = __webpack_public_path__ + "media/customizations/paintedtree/logo-eb60d89b24506731694337530f50b012.png";